<button
  type="button"
  class="drag-handle"
  [class.drag-handle--compact]="compact"
  [disabled]="disabled"
  [attr.aria-label]="label"
  [title]="label"
  (keydown)="keydown.emit($event)">
  <span class="grip-dots" aria-hidden="true">
    <span></span><span></span><span></span>
    <span></span><span></span><span></span>
  </span>
</button>